<template>
	  <div class="pay-container">
	<el-card class="box-card">
	  <!-- <ul class="msg-box">
		<li>
		  <h4>我要充值</h4>
		</li>
		<li>
		  <h4 style="margin-bottom: 15px;">充值点数</h4>
		  <el-radio-group v-model="amountVal" @change="amountChange">
			<el-radio border :label="'100'">充值150点数</el-radio>
			<el-radio border :label="'500'">充值1500点数</el-radio>
			<el-radio border :label="'1000'">充值5000点数</el-radio>
			<el-radio border :label="'2000'">充值2500点数</el-radio>
			<el-radio border :label="'5000'">充值5500点数</el-radio>
			<el-radio border :label="''">自定义</el-radio>
		  </el-radio-group>
		</li>
		<li>
		  <h4 style="margin-bottom: 15px;">充值方式</h4>
		  <el-radio-group v-model="rechargeParams.paymentType" @change="paymentTypeChange">
			<el-radio border :label="'0'">微信</el-radio>
			<el-radio border :label="'1'">支付宝</el-radio>
		  </el-radio-group>
		</li>
		<li>
		  <h4 style="margin-bottom: 15px;">充值金额</h4>
		  <div style="display: flex; align-items: center;">
			<span style="margin-right: 10px; font-size: 16px;">¥</span>
			<el-input 
			  :disabled="disabled" 
			  clearable 
			  v-model.number="rechargeParams.totalAmt" 
			  placeholder="请输入金额" 
			  style="width: 150px;"
			  type="number"
			  :min="0"
			></el-input>
		  </div>
		</li>
	  </ul>
	  <div style="text-align: lift; margin-top: 30px;">
		<el-button 
		  type="primary" 
		  @click="surePay"
		  :loading="loading"
		>确认支付</el-button>
	  </div> -->
	<Watermark 

  :content="watermarkContent"
  :width="watermarkOptions.width"
  :height="watermarkOptions.height"
  :opacity="watermarkOptions.opacity"
  :color="watermarkOptions.color"
  :font-size="watermarkOptions.fontSize"
  :rotate="watermarkOptions.rotate"
>
        <div>
	
	  <!-- 充值历史标题和横线 -->
	  <div style="margin-top: 30px; border-bottom: 1px solid #c5c5c5; padding-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
		<h4 style="margin: 0;">充值历史</h4>
		<el-button type="success" @click="exportToExcel" size="small">
		  <i class="el-icon-download"></i> 导出Excel
		</el-button>
	  </div>
  
	  <!-- 充值历史表格 -->
	  <el-table :data="rechargeHistory" style="width: 100%; margin-top: 20px;">
	  <el-table-column prop="date" label="日期" width="180"></el-table-column>
		<el-table-column prop="task_id" label="任务ID" width="100"></el-table-column>
		<el-table-column prop="payer" label="付款主体" width="180"></el-table-column>
		<el-table-column prop="receiver" label="收款主体" width="180"></el-table-column>
		<el-table-column prop="amount" label="金额" width="180">
		  <template slot-scope="scope">
			¥{{ formatAmount(scope.row.amount) }}
		  </template>
		</el-table-column>
	  </el-table>
	   </div>
      </Watermark>
	</el-card>
	</div>
  </template>
  
  <script>
  import {  getRechargeHistory,
	getRechargeHistory2,
	getRechargeHistory3, 
	getRechargeHistory4,
	getRechargeHistory5,
	getRechargeHistory6,
	getRechargeHistory7,
	getRechargeHistory8,
	getRechargeHistory9,
	getRechargeHistory10,
	getRechargeHistory11,
	getRechargeHistory12,
	getRechargeHistory13,
	getRechargeHistory14,
	


} from '@/api/pay';
  import { Watermark } from '@watermark-design/vue';
  import * as XLSX from 'xlsx';
 
  
  export default {

	components: {
    Watermark, // 注册组件
  },
	data() {
	  return {
		//  watermarkContent: "公司名称", // 水印内容
		  watermarkOptions: { // 水印配置（可选）
        width: 200,
        height: 200,
        opacity: 0.05,
        color: "#ccc",
        fontSize: 14,
        rotate: -20,
      },
		loading: false,
		amountVal: '',
		disabled: false,
		rechargeParams: {
		  totalAmt: null,
		  paymentType: '0',
		  transType: '0'
		},
		rechargeHistory: []
	  }
	},
	methods: {
	  // 格式化金额显示（保留2位小数）
	  formatAmount(amount) {
		if (!amount && amount !== 0) return '0.00'
		const num = Number(amount)
		if (isNaN(num)) return '0.00'
		return num.toFixed(2)
	  },
	  
	  // 其他方法保持不变...
	  amountChange(val) {
		this.rechargeParams.totalAmt = val ? Number(val) : null
		this.disabled = !!val
	  },
  
	  paymentTypeChange(val) {
		this.rechargeParams.paymentType = val
	  },
  
	  async surePay() {
		try {
		  if (!this.validateForm()) return
  
		  this.loading = true
		  const { code, data, msg } = await orderInfo(this.rechargeParams)
		  
		  if (code === 200) {
			this.handlePaymentSuccess(data)
		  } else {
			this.$message.error(msg || '支付请求失败')
		  }
		} catch (error) {
		  console.error('支付错误:', error)
		} finally {
		  this.loading = false
		}
	  },
  
	  validateForm() {
		if (!this.rechargeParams.totalAmt) {
		  this.$message.warning('请输入充值金额')
		  return false
		}
		if (isNaN(this.rechargeParams.totalAmt) || this.rechargeParams.totalAmt <= 0) {
		  this.$message.warning('金额必须大于0')
		  return false
		}
		return true
	  },
  
	  handlePaymentSuccess(result) {
		switch(this.rechargeParams.paymentType) {
		  case '0':
			this.handleWechatPay(result)
			break
		  case '1':
			this.handleAlipayPay(result)
			break
		  default:
			this.$message.error('不支持的支付方式')
		}
	  },
  
	  handleWechatPay(result) {
		this.$message.success('正在跳转微信支付')
		sessionStorage.setItem('payInfo', JSON.stringify({
		  qrurl: result.qr_url,
		  amt: result.amount,
		  order_id: result.order_id
		}))
		this.$router.push({ name: 'wechatPay' })
	  },
  
	  handleAlipayPay(result) {
		this.$message.success('正在跳转支付宝')
		const div = document.createElement('div')
		div.innerHTML = result.payment_form
		document.body.appendChild(div)
		setTimeout(() => {
		  div.querySelector('form').submit()
		  document.body.removeChild(div)
		}, 100)
	  },
	  
	   // 根据用户角色获取对应的API
	   getApiByRole() {
            const userRole = localStorage.getItem('userRole') || 'admin';
            
            // 定义角色与API的映射关系
            const apiMap = {
                'admin': getRechargeHistory,
                'manager': getRechargeHistory2,
                'zhuzhu': getRechargeHistory3,
				'huolong': getRechargeHistory4,
				'buzhi': getRechargeHistory5,
				'ruiqi': getRechargeHistory6,
				'daolai': getRechargeHistory7,
				'yangguang': getRechargeHistory8,
				'jinlianan': getRechargeHistory9,
				'jinlianan2': getRechargeHistory11,
				'dianguang1': getRechargeHistory12,
				'dianguang2': getRechargeHistory13,
				'dianguang3': getRechargeHistory14,

				
				'demo': getRechargeHistory10,
            };
            
            return apiMap[userRole] || getRechargeHistory;
        },
	  async fetchRechargeHistory() {

		const api = this.getApiByRole(); 
		try {
		  const response = await api()
		  if (response.status === 200) {
			this.rechargeHistory = response.data
		  } else {
			this.$message.error(response.msg || '获取充值历史失败')
		  }
		} catch (error) {
		  console.error('获取充值历史错误:', error)
		  this.$message.error('获取充值历史异常')
		}
	  },
	  
	  // 导出Excel
	  exportToExcel() {
		// 准备导出的数据
		const exportData = this.rechargeHistory.map(item => ({
		  日期: item.date,
		  付款主体: item.payer,
		  收款主体: item.receiver,
		  金额: this.formatAmount(item.amount)
		}))
		
		// 创建工作簿
		const wb = XLSX.utils.book_new()
		const ws = XLSX.utils.json_to_sheet(exportData)
		
		// 将工作表添加到工作簿
		XLSX.utils.book_append_sheet(wb, ws, '充值记录')
		
		// 生成Excel文件并下载
		const dateStr = new Date().toISOString().slice(0, 10)
		XLSX.writeFile(wb, `充值记录_${dateStr}.xlsx`)
		
		this.$message.success('导出成功')
	  }
	},
	mounted() {
	  this.fetchRechargeHistory()
	}
  }
  </script>
  
  <style scoped>
  .msg-box > li {
	list-style: none;
	border-bottom: 1px solid #c5c5c5;
	padding: 20px 10px;
  }
  </style>
